/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DevCodeIcon16Light } from './DevCodeIcon16Light';
import { DevCodeIcon16Regular } from './DevCodeIcon16Regular';
import { DevCodeIcon16Solid } from './DevCodeIcon16Solid';
import { DevCodeIcon20Light } from './DevCodeIcon20Light';
import { DevCodeIcon20Regular } from './DevCodeIcon20Regular';
import { DevCodeIcon20Solid } from './DevCodeIcon20Solid';
import { DevCodeIcon24Regular } from './DevCodeIcon24Regular';
import { DevCodeIcon24Solid } from './DevCodeIcon24Solid';
import { DevCodeIcon32Regular } from './DevCodeIcon32Regular';
import { DevCodeIcon64Regular } from './DevCodeIcon64Regular';
var sizes = {
    16: {
        light: DevCodeIcon16Light,
        regular: DevCodeIcon16Regular,
        solid: DevCodeIcon16Solid,
    },
    20: {
        light: DevCodeIcon20Light,
        regular: DevCodeIcon20Regular,
        solid: DevCodeIcon20Solid,
    },
    24: {
        regular: DevCodeIcon24Regular,
        solid: DevCodeIcon24Solid,
    },
    32: {
        regular: DevCodeIcon32Regular,
    },
    64: {
        regular: DevCodeIcon64Regular,
    },
};
export var DevCodeIcon = forwardRef('DevCodeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
